import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Bootstrap 5 moderno
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Tema iPhone personalizado
import './assets/css/local/iphone-theme.css';
import './assets/css/local/performance-enhancements.css';
import './assets/css/local/styles.css';

// Semantic UI mantido para compatibilidade
import 'semantic-ui-css/semantic.min.css';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals